module.exports = __webpack_public_path__ + "static/media/ta-logo-rr-0.f0d8b27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/ta-logo-rr-0.png
// module id = 217
// module chunks = 0